exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bd-header,.bd-main{background:#fff;-webkit-box-shadow:0 2px 10px 0 rgba(39,56,70,.1);box-shadow:0 2px 10px 0 rgba(39,56,70,.1)}.bd-main{margin-top:20px}.bd-main .swTableIcon{-webkit-transform:translateX(-20px);transform:translateX(-20px)}", ""]);

// exports
